export default __webpack_public_path__ + "static/media/glitchy-perchie.d9613062.png";